import { ReportConfirmationContractPDF } from "./Components/PDF/ReportConfirmationContractPDF";
import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { DrawerFilterConfirmationContract } from "./Components/DrawerFilter/DrawerFilterConfirmationContract";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { NoEmptyPdfCore } from "src/Pages/components/PDF/NoEmpty/NoEmptyPdfCore";

export const PageReportConfirmationContract = () => {
  const { loadingGravar } = useConfigPageContext();
  const { listReportConfirmationContract } = useContextReportsProduction();

  const hasData = !!listReportConfirmationContract?.data?.length;

  return (
    <>
      <CardHeaderCore
        buttonAdd={[<DrawerFilterConfirmationContract key="filter" />]}
        icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}
        sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}
        subTitle="Gere relatórios detalhados de parcelas com filtros personalizados"
        title="Relatório de parcelas"
      />

      <ReportConfirmationContractPDF />

      {!hasData && !loadingGravar && <NoEmptyPdfCore />}
    </>
  );
};
